import { VideoJsPlayerOptions } from 'video.js';

import { ImageBlock } from 'components/general/imageBlock/ImageBlock';
import { VideoJSPlayer } from 'components/general/videoBlock/VideoJSPlayer';
import { Link } from 'components/link/Link';
import { useWindowSize } from 'hooks/useWindowSize';
import { MediaType } from 'pages/project/[id]';
import { isMobileWidth } from 'utils/helpers';
import { widont } from 'utils/typography';

import style from './ProjectCard.module.scss';

export type ProjectCardType = {
  title: string;
  blurb: string;
  thumb: MediaType;
  slug: string;
};
export const ProjectCard = ({ title, blurb, slug, thumb }: ProjectCardType): JSX.Element => {
  const size = useWindowSize();
  const isPhone = isMobileWidth(size.width);

  const videoJsOptions: VideoJsPlayerOptions = {
    controls: false,
    responsive: true,
    controlBar: false,
    bigPlayButton: false,
    fill: true,
    autoplay: true,
    preload: 'auto',
    loop: true,
    muted: true,
    poster: isPhone && thumb.phone_image ? thumb.phone_image : thumb.image,

    sources: [
      {
        src: isPhone && thumb.phone_video ? thumb.phone_video : thumb.video!,
      },
    ],
  };

  return (
    <Link href={slug}>
      <a className={style.linkWrapper}>
        <div className={style.container}>
          <div className={style.imageContainer}>
            <div className={style.image}>
              {thumb.video ? (
                <VideoJSPlayer playsInline={true} options={videoJsOptions} onVideoPlay={() => {}} />
              ) : (
                <ImageBlock
                  desktop={{
                    src: thumb.image,
                    layout: 'fill',
                    objectFit: 'cover',
                    loading: 'eager',
                  }}
                  alt={thumb.alt_text}
                />
              )}
            </div>
            <div className={style.copyContainer}>
              <h3 className="sr-only">{title}</h3>
              <p className={style.blurb} dangerouslySetInnerHTML={{ __html: widont(blurb) }} />
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};
